import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
    status: '',
    summary: {},
    monthlyCost: [],
    dailyCost: {},
    resourceId: [],
    usageAccountId: [],
    region: [],
    productCode: [],
    productCategory: [],
    availableTags: [],
    tag: [],
    detail: [],
    itemDescription: []
}

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
}
